import React, { useEffect, useState } from "react";

const TZ_OPTIONS = [
  { value: "Asia/Kolkata", label: "IST" },
  { value: "UTC", label: "UTC" },
  { value: "America/Chicago", label: "CDT" },
  { value: "local", label: "Local" },
];

function buildClockText(tzValue: string): string {
  const tz = tzValue === "local" ? Intl.DateTimeFormat().resolvedOptions().timeZone : tzValue;
  const now = new Date();
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: tz, weekday: "long", month: "short", day: "numeric", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: true, timeZoneName: "short",
  }).formatToParts(now);
  const get = (type: Intl.DateTimeFormatPartTypes) => (parts.find((p) => p.type === type) || ({} as Intl.DateTimeFormatPart)).value || "";
  return `${get("weekday")}, ${get("month")} ${get("day")}, ${get("year")}, ${get("hour")}:${get("minute")} ${get("dayPeriod")} ${get("timeZoneName")}`;
}

const Clock: React.FC = () => {
  const [tz, setTz] = useState<string>("Asia/Kolkata");
  const [text, setText] = useState<string>(() => buildClockText("Asia/Kolkata"));

  useEffect(() => {
    const id = setInterval(() => setText(buildClockText(tz)), 1000);
    return () => clearInterval(id);
  }, [tz]);

  useEffect(() => setText(buildClockText(tz)), [tz]);

  return (
    <div className="clock">
      <span id="utc-clock">{text}</span>
      <select id="tz-select" value={tz} onChange={(e) => setTz(e.target.value)}>
        {TZ_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </div>
  );
};

export default Clock;
